import React, { memo, useEffect, useState } from 'react'
import Image from './Image'
import icons from '../assets/icons'
import { useSwiper } from 'swiper/react'

const SwiperButtons: React.FC = () => {
  const swiper = useSwiper()
  const [isPrevDisabled, setIsPrevDisabled] = useState(false)
  const [isNextDisabled, setIsNextDisabled] = useState(false)

  useEffect(() => {
    const updateButtonStates = () => {
      setIsPrevDisabled(swiper.isBeginning)
      setIsNextDisabled(swiper.isEnd)
    }

    updateButtonStates()

    swiper.on('slideChange', updateButtonStates)

    return () => {
      swiper.off('slideChange', updateButtonStates)
    }
  }, [swiper])

  return (
    <div className='modal--nextCruise--buttons'>
      <div
        onClick={() => swiper.slidePrev()}
        className={`modal--nextCruise--button modal--nextCruise--prev ${
          isPrevDisabled ? 'disabled' : ''
        }`}
      >
        <Image src={icons['arrow-right']} alt='cruise-back' className='' />
      </div>
      <div
        onClick={() => swiper.slideNext()}
        className={`modal--nextCruise--button modal--nextCruise--next ${
          isNextDisabled ? 'disabled' : ''
        }`}
      >
        <Image src={icons['arrow-right']} alt='cruise-next' className='' />
      </div>
    </div>
  )
}

export default memo(SwiperButtons)
